export enum ClaimAdjustmentStatus {
  Default,
  InitialAnalysis,
  InternalAdministration,
  LenderOwners
}
